import type { PropertyOptionalParam } from "web_myplann/Portfolio/Hooks/useGetPropertyOptionalParams";

export const toSelectedKeys = <T>(
	params: PropertyOptionalParam<T>[],
	data: Partial<T>,
): string[] =>
	params.filter(({ key }) => data[key]).map(({ key }) => String(key));

export const toBooleanGroup = <T>(
	params: PropertyOptionalParam<T>[],
	selectedKeys: string[],
): Record<string, boolean> =>
	Object.fromEntries(
		params.map(({ key }) => [String(key), selectedKeys.includes(String(key))]),
	);
